const UNKNOWN_ERROR = "An unknown error has occurred. Please try again later.";

export { UNKNOWN_ERROR };
